// extracted by mini-css-extract-plugin
export var button = "share-module--button--277a4";
export var buttons = "share-module--buttons--679d3";
export var copy = "share-module--copy--b6e19";
export var icon = "share-module--icon--de1fa";
export var label = "share-module--label--ee5f2";
export var line = "share-module--line--6b45b";
export var title = "share-module--title--1266d";
export var wrapper = "share-module--wrapper--911f6";